import { getDefaultOnlineMeetingsEnabled } from 'owa-calendar-cloud-settings';
import { getConfiguredEventStartTimeEndTime } from 'owa-calendar-cloud-settings-utils';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { OwaDateRange } from 'owa-datetime-utils/lib/OwaDateRange';
import { getDefaultOnlineMeetingProvider } from 'owa-online-meeting';
import getDefaultOnlineMeetingEnabled from 'owa-session-store/lib/selectors/getDefaultOnlineMeetingEnabled';
import { orchestrator } from 'satcheljs';
import {
    handleComposePopoutForMeetingDraft,
    onIsOnlineMeetingChanged,
    onDateTimesChanged,
} from 'owa-calendar-compose-form-actions';

export default orchestrator(handleComposePopoutForMeetingDraft, () => {
    const { event } = getComposeStore();

    // Checks both the OCS setting and calendar mailbox configuration setting
    // Bug 84744: [OnlineMeetings] Investigate replyByMeeting when using OCS settings
    const defaultOnlineMeetingsEnabled =
        getDefaultOnlineMeetingsEnabled() || getDefaultOnlineMeetingEnabled();

    // Update default online meeting if the setting is enabled
    if (!event.IsOnlineMeeting && defaultOnlineMeetingsEnabled) {
        onIsOnlineMeetingChanged(
            true /* IsOnlineMeeting */,
            getDefaultOnlineMeetingProvider(event),
            false /* isOnlineMeetingExplicitlySet */
        );
    }

    // Adjust startDate and endDate based on the shorten event duration setting
    const adjustedDateRange: OwaDateRange = getConfiguredEventStartTimeEndTime(
        event.Start,
        event.End
    );
    onDateTimesChanged({ start: adjustedDateRange.start, end: adjustedDateRange.end });
});
